import { render } from "./ModalDeleteConfirmation.vue?vue&type=template&id=2b506f92&scoped=true"
import script from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"

import "./ModalDeleteConfirmation.vue?vue&type=style&index=0&id=2b506f92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b506f92"]])

export default __exports__